import { IcFire, IcMedicalCross, IcPolice } from '@/assets/images';
import { AgencyType, AssignmentStatus, TSeverity } from '@/models';

export const requiredUnitFields = [
  {
    name: 'Police',
    agencyType: AgencyType.POLICE,
    icon: IcPolice,
  },
  {
    name: 'Fire',
    agencyType: AgencyType.FIRE,
    icon: IcFire,
  },
  {
    name: 'EMS',
    agencyType: AgencyType.EMS,
    icon: IcMedicalCross,
  },
];

export const activeCFSTableColumns = [
  { width: '10%', key: '_id', label: 'CFS ID' },
  { width: '10%', key: 'status', label: 'Status' },
  { width: '9%', key: 'shortDescription', label: 'Short Description' },
  { width: '10%', key: 'location', label: 'Location' },
  { width: '10%', key: 'linkedCases', label: 'Case ID' },
  { width: '7%', key: 'assignedAgencies', label: 'Agencies' },
  { width: '9%', key: 'incidentCodes', label: 'Incident Codes' },
  { width: '14%', key: 'assignedUnitShifts', label: 'Unit assignment' },
  { width: '7%', key: 'receivedAt', label: 'Received at' },
  { width: '8%', key: 'duration', label: 'Live Timer' },
  { width: '6%', key: 'action', label: 'Actions' },
];

export const filterMenuFormFields = [
  {
    name: 'agencyType',
    type: 'autocomplete',
    label: 'Agency Type',
    multiple: true,
    items: [
      { label: 'EMS', value: 'EMS' },
      { label: 'Fire', value: 'FIRE' },
      { label: 'Police', value: 'POLICE' },
      {
        label: 'Emergency Management',
        value: AgencyType.EMERGENCY_MANAGEMENT,
      },
      {
        label: 'Municipal Services',
        value: AgencyType.MUNICIPAL_SERVICES,
      },
    ],
  },
  {
    name: 'agencies',
    type: 'autocomplete',
    label: 'Agency',
    multiple: true,
  },
  {
    name: 'assignmentStatus',
    type: 'autocomplete',
    label: 'Status',
    items: [
      { label: 'New', value: AssignmentStatus.NEW },
      { label: 'Ready for Dispatch', value: 'isReadyToDispatch' },
      { label: 'Partially Assigned', value: AssignmentStatus.PARTIAL_ASSIGNED },
      { label: 'Assigned', value: AssignmentStatus.ASSIGNED },
    ],
  },
  {
    name: 'severity',
    type: 'autocomplete',
    label: 'Severity',
    items: [
      { label: 'HIGH', value: TSeverity.HIGH },
      { label: 'MEDIUM', value: TSeverity.MEDIUM },
      { label: 'LOW', value: TSeverity.LOW },
    ],
  },
];
